import { SelectionModel } from '@angular/cdk/collections';
import { Component, signal, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ListaMateriais } from 'src/app/model/ListaMateriais';
import { CarrinhoService } from 'src/app/service/carrinho.service';
import { StorageService } from 'src/app/service/shared/storage.service';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';

@Component({
  selector: 'app-lista-material',
  templateUrl: './lista-material.component.html',
  styleUrls: ['./lista-material.component.scss']
})
export class ListaMaterialComponent {

  public readonly aba: string = 'listaMaterial';

  public id_form_envio = JSON.parse(this.storage.getEscola()).id_forma_envio;

  public nome_escola!: string;

  public form!: FormGroup;

  public isLoading: boolean = false;

  public listaMateriais!: ListaMateriais[]
  public listaProdutos!: any[]

  public totalPorDependente: any = [];
  public total!: any;

  public displayedColumns: string[] = ['select', 'desc_produto', 'preco'];
  public dataSource = new MatTableDataSource<ListaMateriais>();
  public selection = new SelectionModel<any>(true, []);

  @ViewChild(MatSort) sort!: MatSort;

  public itens_humanas: any[] = [];
  public itens_natureza: any[] = [];

  public isTerceiroAno = signal<boolean>(false);

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private storage: StorageService,
    private carrinho: CarrinhoService,
    private dialog: MatDialog,
  ) {
  }

  ngOnInit(): void {
    if (this.storage.isloggedIn()) {
      this.nome_escola = JSON.parse(this.storage.getEscola()).nome_escola;
      this.carregaListaDeItens();
      this.initForm();
    } else {
      this.router.navigate(['/'])
    }
  }

  public enviaListaMateriais() {
    const dados = this.selecionaItens();

    if (this.selection.selected.length != 0) {
      this.carrinho.addCarrinho(dados).subscribe({
        next: (res) => {
          if (res.status) {
            this.router.navigate(['/endereco-entrega']);
          } else {
            this.dialog.open(DialogComponent, { data: res.mensagem })
              .afterClosed()
          }
        },
        error: (res) => this.dialog.open(DialogComponent, { data: res }).afterClosed()
      })
    } else {
      this.dialog.open(DialogComponent, { data: 'Você precisa selecionar, pelo menos, um item.' });
    }
  }

  public selecionaItens() {
    const produtosPorDependente: any = {};
    const guid = this.storage.getGUID();

    this.selection.selected.forEach(item => {
      const idSerie = item.id_serie;
      const idDependente = item.id_dependente;

      if (!produtosPorDependente[idDependente]) {
        produtosPorDependente[idDependente] = {
          id_dependente: idDependente,
          id_serie: idSerie,
          produtos: []
        };
      }

      produtosPorDependente[idDependente].produtos.push(item);
    });

    const produtosSelecionados = {
      guid: guid,
      dependentes: Object.values(produtosPorDependente)
    };

    return produtosSelecionados;
  }

  private initForm() {
    this.form = this.formBuilder.group({
      nome_dependente: ['', Validators.required],
      id_serie: ['', Validators.required]
    })
  }

  private carregaListaDeItens() {
    const GUID = {
      guid: this.storage.getGUID()
    };
    this.isLoading = true;

    this.carrinho.listaMateriais(GUID).subscribe((lista) => {
      if (lista.status == false) {
        this.router.navigate(['/dependente']);
      } else {
        this.listaMateriais = lista;

        this.dataSource = new MatTableDataSource<any>(lista.produtos);
        this.dataSource.sort = this.sort;
        this.isLoading = false;
        this.adicionandoId();
        this.checkAll(this.listaMateriais);
        this.operacaoTotalPorDependente();
      }
    });
  }

  public adicionandoId() {
    this.listaMateriais.forEach(dependente => {

      // verifica a serie de todos os dependentes e se existir algum dependente com o id 15, exibe mensagem. 
      if (dependente.id_serie === 15) {
        // seta que é terceiro ano
        this.isTerceiroAno.set(true);
        
        // pega os itens do itinerario
        this.carrinho.getItinerario().subscribe((res) => {
          this.itens_humanas = res.data.itens_grupo1;
          this.itens_natureza = res.data.itens_grupo2;
          // this.dialog.open(DialogListaComponent, { data: res})
        });
      }

      dependente.produtos.forEach(produto => {
        produto = Object.assign(produto, { id_dependente: dependente.id_dependente })
      })
    })
  }

  private checkAll(listaMateriais: any) {
    listaMateriais.forEach((item: any) => {
      item.produtos.forEach((element: any) => {
        this.selection.select(element);
      });
    });
  }

  public valoresProdutosSelecionados() {
    const valorProdutoPorDependente: any = [];

    this.selection.selected.forEach(item => {
      const idSerie = item.id_serie;
      const idDependente = item.id_dependente;

      if (!valorProdutoPorDependente[idDependente]) {
        valorProdutoPorDependente[idDependente] = {
          id_dependente: idDependente,
          id_serie: idSerie,
          produtos: []
        };
      }

      valorProdutoPorDependente[idDependente].produtos.push(item);
    });

    const valoresSelecionados = {
      dependentes: Object.values(valorProdutoPorDependente)
    };

    return valoresSelecionados;
  }

  public operacaoTotalPorDependente() {
    const valores = this.valoresProdutosSelecionados();

    // Inicializa o totalPorDependente como um objeto vazio
    this.totalPorDependente = {};

    valores.dependentes.forEach((dependente: any) => {
      let soma = 0;

      // Verifica se há produtos para o dependente antes de calcular a soma
      if (dependente.produtos && dependente.produtos.length > 0) {
        dependente.produtos.forEach((produto: any) => {
          soma += parseFloat(produto.valor);
        });
      }

      // Atualiza o totalPorDependente apenas se houver produtos selecionados
      this.totalPorDependente[dependente.id_dependente] = soma;
    });

    // Verifica se todos os produtos foram desselecionados e redefine o total para zero
    if (this.selection.isEmpty()) {
      this.totalPorDependente = {};
    }

    // Calcula a soma total de todos os valores em totalPorDependente
    this.total = Object.values(this.totalPorDependente).reduce((acc: any, value) => acc + value, 0);
  }

  public continuar() {
    this.enviaListaMateriais();
  }

  public isInvalid(ctrlName: string): boolean | undefined {
    return this.form.get(ctrlName)?.invalid;
  }

  public mensagemDeErro(ctrlName: string) {
    const field = this.form.get(ctrlName);

    if (field?.hasError('required')) {
      return 'Preencha o campo.';
    } else {
      return '';
    }
  }
}
